module.exports = __webpack_public_path__ + "static/media/enlarge-image.447a27d6.png";